import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from '../prime-ng/prime-ng.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '../material/material.module';

@NgModule({
  declarations: [],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    PrimeNgModule,
    CommonModule,
    NgbModule,
    MaterialModule,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    PrimeNgModule,
    NgbModule,
    MaterialModule
  ]
})
export class SharedModule {}
